import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import { Pages } from './pagesInfo';
import { Link } from 'react-router-dom';
import { Typography, Fade } from '@mui/material';
import TitleChange from './titleChanger.js';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));
const pages = Pages();
export default function Links() {

    TitleChange("Fraser A Campbell - Links");

    return (
        <div>
            <Fade in mountOnEnter unmountOnExit timeout={3000}>
                <Typography sx={{ marginTop: { xs: '7rem', md: '6rem' }, marginBottom: '1rem' }} variant="h4" color="cornflowerblue">Links</Typography>
            </Fade>
            <Fade in mountOnEnter unmountOnExit timeout={3000}>
                <Box sx={{ width: '100%' }}>
                    <Stack sx={{ marginBottom: '5rem' }} spacing={2}>
                        {pages.map((page) => (
                            <Item><Link to={page.loc}><Typography variant='body1' color='gold'>{page.title}</Typography></Link></Item>
                        ))}
                    </Stack>
                </Box>
            </Fade>
        </div>
    );
}